<template>
  <div>
    <template v-if="isxufei">
      <h3 style="text-align: center">{{ titleNameWord }}</h3>
      <div class="shopBox">
        <!-- 账号信息 -->
        <div class="shop-item">
          <div class="item-top-xufei">
            <div class="word word_1">可续费账号等级</div>
            <van-tag type="success" size="medium">
              {{ xufeiItem.productname }} ({{
                moment(xufeiItem.starttime).format("YYYY-MM-DD")
              }}
              - {{ moment(xufeiItem.endtime).format("YYYY-MM-DD") }}) </van-tag
            ><span style="color: #07c160">(已购)</span>
            <div class="word word_1">续费时长</div>
          </div>
          <div class="chooseYear bottom-line">
            <div
              class="one"
              :class="{ yearActive: currentYearIndex === index }"
              v-for="(year, index) in years"
              :key="index"
              @click="changeYear(year, index)"
            >
              <p class="year">{{ year.salenumber }}年</p>

              <p
                style="color: #a17d59; font-size: 16px; margin: 18px 0"
                class="year"
              >
                {{ year.discountname }}
              </p>
              <p>
                <van-tag color="#A17D59">{{ year.discountdesc }}</van-tag>
              </p>
            </div>
          </div>
          <!-- <div class="item-center">
            <div class="word">配置:</div>
            <div class="tag">
              <van-tag
                text-color="#727272"
                color="#AAA6A6"
                plain
                v-for="(tag, index) in xufeiItem.BasePackageFun"
                :key="index"
                style="background-color: #f7f7f7"
                >{{ tag.alias }}</van-tag
              >
            </div>
          </div> -->
        </div>
        <!-- 优惠信息 -->
        <div style="margin-top: 20px" v-if="!isxufei">
          <p style="font-size: 14px; color: #656565; margin-bottom: 20px">
            优惠信息
          </p>
          <van-field
            v-if="!isxufei"
            v-model="coupon"
            center
            clearable
            label="优惠码"
            placeholder="请输入优惠码"
            @clear="clearCoupon"
            :disabled="checked ? true : false"
          >
          </van-field>
          <van-field
            v-model="agentCode"
            v-if="!isxufei"
            center
            clearable
            label="运营商编码"
            placeholder="请输入运营商编码"
            @clear="clearCoupon"
            :disabled="checked ? true : false"
          >
          </van-field>
          <van-cell title=" ">
            <template #right-icon>
              <span style="margin-right: 10px"
                >确认使用{{ isConpponma ? "优惠码和" : "" }}运营商编码</span
              >
              <van-checkbox
                :disabled="coupon || agentCode ? false : true"
                @change="changeChecked"
                v-model="checked"
              />
            </template>
          </van-cell>
          <van-cell title=" ">
            <template #right-icon>
              <span style="margin-right: 10px; color: green">{{
                checked ? alertMessage_1 : ""
              }}</span>
            </template>
          </van-cell>
        </div>
        <!-- 发票 -->
        <div style="margin-top: 20px" @click="drawABill">
          <van-cell title="发票" is-link :value="invoiceWord" />
        </div>
        <!-- 选择支付方式 -->
        <div class="payMethods">
          <p>请选择支付方式</p>
          <van-radio-group v-model="radioPay">
            <van-cell-group>
              <van-cell clickable @click="radioPay = '1'">
                <template #title>
                  <van-image width="30" height="30" :src="wxImg" />
                  <span class="custom-title">微信支付</span>
                </template>
                <template #right-icon>
                  <van-radio name="1" />
                </template>
              </van-cell>
              <!-- <van-cell clickable @click="radioPay = '2'">
                  <template #title>
                    <van-image width="30" height="30" :src="zfbImg" />
                    <span class="custom-title">支付宝支付</span>
                  </template>
                  <template #right-icon>
                    <van-radio name="2" />
                  </template>
                </van-cell> -->
            </van-cell-group>
          </van-radio-group>
        </div>
        <!-- 去支付 -->
        <van-submit-bar
          :disabled="totalPrice > 0 ? false : true"
          :price="totalPrice"
          button-text="去支付"
          :loading="loadingFlag ? true : false"
          @submit="confirmPayment"
        >
          <!-- <del style="color: #ccc;">原价：{{ oldPrice | toDecimal }}</del> -->
        </van-submit-bar>
      </div>
    </template>
    <template v-else-if="!isxufei">
      <h3 style="text-align: center">{{ titleNameWord }}</h3>
      <div class="shopBox">
        <!-- 账号信息 -->
        <div class="shop-item">
          <div class="item-top-goumai">
            <!-- <div v-if="nowSellProduct.code === '000001'" class="img">
              <img src="../../../assets/shop/1.png" />
            </div>
            <div v-if="nowSellProduct.code === '000002'" class="img">
              <img src="../../../assets/shop/2.png" />
            </div>
            <div v-if="nowSellProduct.code === '000003'" class="img">
              <img src="../../../assets/shop/3.png" />
            </div>
            <div v-if="nowSellProduct.code === '000004'" class="img">
              <img src="../../../assets/shop/4.png" />
            </div> -->
            <div class="money">
              <div class="title">{{ nowSellProduct.name }}</div>
              <div>
                <van-tag color="#FE504F" plain>{{
                  nowSellProduct.desc
                }}</van-tag>
              </div>
            </div>
          </div>
          <div class="chooseYear bottom-line">
            <div
              class="one"
              :class="{ yearActive: currentYearIndex === index }"
              v-for="(year, index) in years"
              :key="index"
              @click="changeYear(year, index)"
            >
              <p class="year">{{ year.salenumber }}年</p>

              <p
                style="color: #a17d59; font-size: 16px; margin: 18px 0"
                class="year"
              >
                {{ year.discountname }}
              </p>
              <p>
                <van-tag color="#A17D59">{{ year.discountdesc }}</van-tag>
              </p>
            </div>
          </div>
          <div class="item-center">
            <div class="word">配置:</div>
            <div class="tag">
              <van-tag
                text-color="#727272"
                color="#AAA6A6"
                plain
                v-for="(tag, index) in nowSellProduct.BasePackageFun"
                :key="index"
                style="background-color: #f7f7f7"
                >{{ tag.alias }}</van-tag
              >
            </div>
          </div>
        </div>
        <!-- 优惠信息 -->
        <div style="margin-top: 20px" v-if="!isxufei">
          <p style="font-size: 14px; color: #656565; margin-bottom: 20px">
            优惠信息
          </p>
          <van-field
            v-if="!isxufei"
            v-model="coupon"
            center
            clearable
            label="优惠码"
            placeholder="请输入优惠码"
            @clear="clearCoupon"
            :disabled="checked ? true : false"
          >
          </van-field>
          <van-field
            v-model="agentCode"
            v-if="!isxufei"
            center
            clearable
            label="运营商编码"
            placeholder="请输入运营商编码"
            @clear="clearCoupon"
            :disabled="checked ? true : false"
          >
          </van-field>
          <van-cell title=" ">
            <template #right-icon>
              <span style="margin-right: 10px"
                >确认使用{{ isConpponma ? "优惠码和" : "" }}运营商编码</span
              >
              <van-checkbox
                :disabled="coupon || agentCode ? false : true"
                @change="changeChecked"
                v-model="checked"
              />
            </template>
          </van-cell>
          <van-cell title=" ">
            <template #right-icon>
              <span style="margin-right: 10px; color: green">{{
                checked ? alertMessage_1 : ""
              }}</span>
            </template>
          </van-cell>
        </div>
        <!-- 发票 -->
        <div style="margin-top: 20px" @click="drawABill">
          <van-cell title="发票" is-link :value="invoiceWord" />
        </div>
        <!-- 选择支付方式 -->
        <div class="payMethods">
          <p>请选择支付方式</p>
          <van-radio-group v-model="radioPay">
            <van-cell-group>
              <van-cell clickable @click="radioPay = '1'">
                <template #title>
                  <van-image width="30" height="30" :src="wxImg" />
                  <span class="custom-title">微信支付</span>
                </template>
                <template #right-icon>
                  <van-radio name="1" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
        <!-- 去支付 -->
        <van-submit-bar
          :disabled="totalPrice > 0 ? false : true"
          :price="totalPrice"
          button-text="去支付"
          :loading="loadingFlag ? true : false"
          @submit="confirmPayment"
        >
        </van-submit-bar>
      </div>
    </template>

    <!-- 开票弹框页面 -->
    <invoice-page
      ref="invoice"
      :totalPrice="totalPrice"
      @getInvoiceParams="getInvoiceParams"
    ></invoice-page>

    <!-- 合同内容 用户协议 -->
    <van-popup
      v-model="userAgreement"
      @close="closePopup"
      closeable
      close-icon="close"
      position="top"
      :style="{ height: '100%', width: '100%', backgroundColor: '#F5F5F5' }"
    >
      <div id="word_11"></div>
      <user-agreement-pop
        :userAgreementData="userAgreementData"
        :sumMoney="sumMoney"
      ></user-agreement-pop>
      <van-tabbar
        :border="false"
        style="
            background-color: #fff;
            diaplay: flex;
            justify-content: center;
            align-items: center;
            height: 50px;
          "
      >
        <van-button
          style="height: 70%; width: 4rem"
          type="info"
          block
          round
          size="small"
          @click="agreePayMoney"
          >同意并确认支付</van-button
        >
        <van-button
          style="height: 70%; width: 100px; margin-left: 20px"
          type="default"
          block
          round
          size="small"
          @click="closePopup"
          >取消支付</van-button
        >
      </van-tabbar>
    </van-popup>
  </div>
</template>

<script>
import InvoicePage from "@/components/common/invoice";
import userAgreementPop from "@/components/newcommon/userAgreement";
import { wxpayFunc } from "@/utils/lib/wxpay.js";
import { commonToast, commonNotify, warningNotify } from "@/utils/lib/toast.js";

export default {
  components: {
    InvoicePage,
    userAgreementPop,
  },
  data() {
    return {
      isxufei: false, // 是否是续费
      xufeiArr: [],
      xufeiItem: {}, // 续费的那一个
      productsData: {},
      nowSellProduct: {}, // 当前在卖的
      years: [],
      year: {},
      currentYearIndex: 0, // 选中的年份

      oldPrice: 0, // 原价
      totalPrice: 0, // 总价 格式 0000
      totalMoney: 0, // 总价 格式 0.00
      totalPriceYou: 0,
      totalMoneyYou: 0,
      loadingFlag: false,

      checked: false, // 是否选用优惠码
      coupon: "", // 优惠码
      agentCode: "", // 运营商编码
      iconCouponFlag: false, // 优惠码的错误提示信息
      iconAgentCodeFlag: false, // 运营商编码的错误提示信息
      alertMessage: "", // 优惠码提示信息
      alertMessage_1: "", // 优惠码返回的优惠信息
      isConpponma: true, // 是否有优惠码

      invoiceWord: "", // 发票信息
      invoiceData: {
        // 发票弹框的内容
        invoicetype: 1,
        invoiceheader: {
          headertype: 1,
          headername: "个人",
          headercode: "",
          officeaddress: "",
          mobilenumber: "",
          bankname: "",
          bankaccount: "",
        },
      },
      invoiceWord: "普通发票 个人",

      radioPay: "1", // 支付方式

      wxImg: require("../../../assets/shop/wx.png"),

      browser: "", // 是否是微信浏览器
      wxpayObj: "", // 微信支付参数
      dataForm: "", // 跳转地址
      userAgreementData: {}, // 合同返回得内容
      sumMoney: 0, // 合同中的合计
      userAgreement: false, // 用户协议
      titleNameWord: "",
    };
  },
  computed: {
    accounttype() {
      return this.$store.state.user.accounttype;
    },
    wxopenid: {
      get() {
        return this.$store.state.user.wxopenid;
      },
      set() {},
    },
    accountstatus() {
      return this.$store.state.user.accountstatus;
    },
  },
  created() {
    this.titleNameWord = this.titleName();
    this.getProductList();
  },
  methods: {
    // 商城页面 账号等级 提示信息
    titleName() {
      console.log("this.accounttype", this.accounttype, this.accountstatus);
      if (this.accounttype == 4) {
        return "系统已匹配出您可以续购的账号等级";
      } else if (this.accounttype == 2 || this.accounttype == 3) {
        return "请与单位管理员联系";
      } else if (this.accountstatus == 200 || this.accountstatus == 207) {
        return "持续续费，尊享账号等级配置权益";
      } else if (
        this.accountstatus == 100 ||
        this.accountstatus == 107 ||
        this.accountstatus == 300 ||
        this.accountstatus == 400
      ) {
        return "购买账号等级，尊享账号等级配置权益";
      }
    },
    // 获取商品列表
    getProductList() {
      console.log("titleNameWord", this.titleNameWord);
      this.$http
        .reqGetProductLists()
        .then((res) => {
          if (res.rtncode === 1) {
            if (res.rltcode === 1) {
              if (res.data.effectiveorders.length > 0) {
                this.isxufei = true;
                this.xufeiArr = res.data.effectiveorders;
                this.xufeiItem = this.xufeiArr[this.xufeiArr.length - 1];
                this.getProductDiscount(this.xufeiItem.productcode);
              } else {
                this.productsData = res.data;
                this.productsData.products.find((item) => {
                  item.publishstate === 2 && (this.nowSellProduct = item);
                });
                this.getProductDiscount(this.nowSellProduct.code);
              }
            }
          }
        })
        .catch((err) => {
          console.log("获取商品列表", err);
        });
    },
    // 获取优惠列表
    getProductDiscount(code) {
      this.$http
        .reqGetProductDiscount(code)
        .then((res) => {

          if (res.rtncode === 1) {
            if (res.rltcode === 1) {
              this.years = res.item;
              this.year = res.item[0];
              this.oldPrice = Number(this.year.oriprice); // 原价
              this.totalMoney = Number(this.year.newprice);
              this.totalPrice = Number(this.year.newprice) * 100;
              this.totalMoneyYou = Number(this.year.newprice);
              this.totalPriceYou = Number(this.year.newprice) * 100;
            }
          }
          this.firstGetInvoiceParams();
        })
        .catch((err) => {
          console.log("获取优惠信息", err);
        });
    },
    // 第一次获取已开发票的内容
    firstGetInvoiceParams() {
      this.$http
        .getInvoiceHeader()
        .then((res) => {
          if (res.rtncode === 1 && res.rltcode === 1 && res.item != null) {
            if (res.item.headertype === 1) {
              // 个人
              this.invoiceWord = "普通发票 个人";
              this.invoiceData.invoiceheader = res.item;
            } else if (res.item.headertype === 2) {
              // 公司
              this.invoiceWord = "普通发票 单位";
              this.invoiceData.invoiceheader = res.item;
            }
            this.$refs.invoice.inputMsg(res.item);
            if (this.$route.query.warninglevel === "3") {
              this.$emit("changeVanTabs", 1);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 年份切换
    changeYear(year, index) {
      console.log("index", year, index);
      this.currentYearIndex = index;
      this.year = year;
      this.oldPrice = Number(year.oriprice); // 原价
      this.totalMoney = Number(year.newprice);
      this.totalPrice = Number(year.newprice) * 100;

      this.totalMoneyYou = Number(year.newprice);
      this.totalPriceYou = Number(year.newprice) * 100;

      this.caleCouponCodeAndAgentCode();
    },
    // 清空优惠码
    clearCoupon() {},
    // 是否使用运营商及优惠码
    changeChecked(name) {
      if (name == true) {
        this.caleCouponCodeAndAgentCode();
      } else {
        this.totalMoney = this.totalMoneyYou;
        this.totalPrice = this.totalPriceYou;
        this.alertMessage_1 = "";
        console.log(
          "this.totalMoney===false",
          this.totalMoney,
          this.totalPrice
        );
      }
    },
    // 发票
    drawABill() {
      this.$refs.invoice.openpopup();
      this.$refs.invoice.getTotalMoney(this.totalMoney);
    },
    // 主套餐 确认支付
    confirmPayment() {
      if (this.isConpponma && !this.isxufei) {
        if (!this.checked) {
          this.alertDialog_1(
            "您没有确认使用优惠码和运营商编码，是否继续下单？"
          );
        } else {

          if (
            this.iconCouponFlag &&
            this.iconAgentCodeFlag &&
            this.coupon &&
            !this.agentCode
          ) {
            this.alertDialog_1("您没有填写运营商编码，是否继续下单？");
          } else if (
            this.iconCouponFlag &&
            !this.iconAgentCodeFlag &&
            this.agentCode &&
            !this.coupon
          ) {
            this.alertDialog_1(
              `您没有填写优惠码且${this.alertMessage}，是否继续下单？`
            );
          } else if (
            !this.iconCouponFlag &&
            this.iconAgentCodeFlag &&
            this.coupon &&
            !this.agentCode
          ) {
            this.alertDialog_1(
              `您没有填写运营商编码且${this.alertMessage}，是否继续下单？`
            );
          } else if (
            !this.iconCouponFlag &&
            this.iconAgentCodeFlag &&
            this.coupon &&
            this.agentCode
          ) {
            this.alertDialog_1(`${this.alertMessage}，是否继续下单？`);
          } else if (
            this.iconCouponFlag &&
            !this.iconAgentCodeFlag &&
            this.coupon &&
            this.agentCode
          ) {
            this.alertDialog_1(`${this.alertMessage}，是否继续下单？`);
          } else if (
            !this.iconCouponFlag &&
            !this.iconAgentCodeFlag &&
            this.coupon &&
            this.agentCode
          ) {
            this.alertDialog_1(`${this.alertMessage}，是否继续下单？`);
          } else if (
            this.iconCouponFlag &&
            this.iconAgentCodeFlag &&
            this.coupon &&
            this.agentCode
          ) {
            console.log(
              this.iconCouponFlag,
              this.iconAgentCodeFlag,
              this.coupon,
              this.agentCode
            );
            this.onConfirm_1();
          } else if (
            this.iconCouponFlag &&
            this.iconAgentCodeFlag &&
            !this.coupon &&
            this.agentCode
          ) {
            this.alertDialog_1(`您还没有选择优惠码，是否继续下单？`);
          }
        }
      } else {
        if (!this.checked && !this.isxufei) {
          this.alertDialog_1("您没有确认使用运营商编码，是否继续下单？");
        } else {
          this.onConfirm_1();
        }
      }
    },
    // 提示信息弹框
    alertDialog_1(message) {
      this.$dialog
        .confirm({
          title: "提示",
          message: message,
          confirmButtonText: "下单",
        })
        .then(() => {
          // on confirm
          this.onConfirm_1();
        })
        .catch(() => {
          // on cancel
        });
    },
    onConfirm_1() {
      this.loadingFlag = true;
      if (this.radioPay == "1") {
        this.isWeixin();
      } else if (this.radioPay === "2") {
        console.log("支付宝支付");
      }
    },
    // 计算优惠码和运营商编码优惠信息
    caleCouponCodeAndAgentCode() {
      if (this.checked) {
        let params = {
          amount: this.totalMoney,
          couponcode: this.coupon,
          agentcode: this.agentCode,
        };
        this.$http
          .reqCaleCouponCodeAndAgentCode(params)
          .then((res) => {
            if (res.rtncode === 1) {
              if (res.rltcode === 1) {
                if (res.item.couponrlt && res.item.agentrlt) {
                  this.iconCouponFlag = true;
                  this.iconAgentCodeFlag = true;
                  this.totalMoney = res.item.amount;
                  this.totalPrice = res.item.amount * 100; // 折后价
                  this.alertMessage_1 = res.item.discountdesc;
                } else if (!res.item.couponrlt && res.item.agentrlt) {
                  this.iconCouponFlag = false;
                  this.iconAgentCodeFlag = true;
                  this.alertMessage = res.item.couponrltdesc;
                  this.alertMessage_1 = res.item.discountdesc;
                } else if (res.item.couponrlt && !res.item.agentrlt) {
                  this.iconCouponFlag = true;
                  this.iconAgentCodeFlag = false;
                  this.alertMessage = res.item.agentrltdesc;
                  this.alertMessage_1 = res.item.discountdesc;
                } else if (!res.item.couponrlt && !res.item.agentrlt) {
                  this.iconCouponFlag = false;
                  this.iconAgentCodeFlag = false;
                  this.alertMessage = `${res.item.couponrltdesc}，${res.item.agentrltdesc}`;
                  this.alertMessage_1 = res.item.discountdesc;
                }
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    // 获取发票弹框的内容
    getInvoiceParams(params, word) {
      this.invoiceData = params;
      this.invoiceWord = word;
    },

    isWeixin() {
      var ua = window.navigator.userAgent.toLowerCase();
      // 微信浏览器内
      let params;
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        this.browser = "wx";
        if (this.isxufei) {
          params = {
            product: this.xufeiItem.productcode, // 购买的产品
            discount: this.year.discountcode, // 选择的优惠方式
            paytype: 32, // 支付方式，10 支付宝扫码，30 微信扫码，31 微信H5支付 32 微信内支付
            couponcode: this.iconCouponFlag ? this.coupon : "", // 优惠码或优惠卷代码
            agentcode: this.agentCode, // 运营商编码
            invoice: this.invoiceData, // 开票相关信息
            wxopenid: sessionStorage.getItem("wxopenid"),
          };
          

          this.$http
            .reqPostProductContinueOrder(params)
            .then((res) => {
              if (res.rtncode === 1) {
                if (res.rltcode === 1) {
                  // this.dataForm = res.result.strdata;
                  this.wxpayObj = JSON.parse(res.result.strdata);
                  this.getUserAgreement(res.result.orderid, "main");
                } else {
                  commonToast(res.rltdesc, this);
                }
              }
            })
            .catch((err) => {
              this.loadingFlag = false;
            });
        } else {
          params = {
            product: this.nowSellProduct.code, // 购买的产品
            discount: this.year.discountcode, // 选择的优惠方式
            paytype: 32, // 支付方式，10 支付宝扫码，30 微信扫码，31 微信H5支付  32微信内支付
            couponcode: this.iconCouponFlag ? this.coupon : "", // 优惠码或优惠卷代码
            agentcode: this.iconAgentCodeFlag ? this.agentCode : "", // 运营商编码
            invoice: this.invoiceData, // 开票相关信息
            wxopenid: this.wxopenid,
          };
          

          this.$http
            .reqPostProduceOrder(params)
            .then((res) => {
              
              if (res.rtncode === 1) {
                if (res.rltcode === 1) {
                  this.wxpayObj = JSON.parse(res.result.strdata);
                  this.getUserAgreement(res.result.orderid, "main");
                  // this.userAgreement = true;
                } else {
                  commonToast(res.rltdesc, this);
                  this.loadingFlag = false;
                }
              } else {
                commonToast(res.rltdesc, this);
                this.loadingFlag = false;
              }
            })
            .catch((err) => {
              this.loadingFlag = false;
            });
        }
      } else {
        // 非微信浏览器
        if (this.isxufei) {
          params = {
            product: this.xufeiItem.productcode, // 购买的产品
            discount: this.year.discountcode, // 选择的优惠方式
            paytype: 31, // 支付方式，10 支付宝扫码，30 微信扫码，31 微信H5支付
            couponcode: this.iconCouponFlag ? this.coupon : "", // 优惠码或优惠卷代码
            agentcode: this.agentCode, // 运营商编码
            invoice: this.invoiceData, // 开票相关信息
          };
          this.$http
            .reqPostProductContinueOrder(params)
            .then((res) => {
              if (res.rtncode === 1) {
                if (res.rltcode === 1) {
                  this.dataForm = res.result.strdata;

                  this.getUserAgreement(res.result.orderid, "main");
                } else {
                  commonToast(res.rltdesc, this);
                }
              }
            })
            .catch((err) => {
              this.loadingFlag = false;
              console.log(err);
            });
        } else {
          params = {
            product: this.nowSellProduct.code, // 购买的产品
            discount: this.year.discountcode, // 选择的优惠方式
            paytype: 31, // 支付方式，10 支付宝扫码，30 微信扫码，31 微信H5支付
            couponcode: this.iconCouponFlag ? this.coupon : "", // 优惠码或优惠卷代码
            agentcode: this.iconAgentCodeFlag ? this.agentCode : "", // 运营商编码
            invoice: this.invoiceData, // 开票相关信息
          };
        
          this.$http
            .reqPostProduceOrder(params)
            .then((res) => {
              if (res.rtncode === 1) {
                if (res.rltcode === 1) {
                  this.dataForm = res.result.strdata;
                  this.getUserAgreement(res.result.orderid, "main");
                } else {
                  commonToast(res.rltdesc, this);
                  this.loadingFlag = false;
                }
              }
            })
            .catch((err) => {
              this.loadingFlag = false;
            });
        }
      }
    },
    // 获取用户协议的内容
    getUserAgreement(orderid, type) {
      this.$http
        .reqGetContractinfo(orderid)
        .then((res) => {
          if (res.rtncode === 1 && res.rltcode === 1) {
            this.userAgreementData = res.item;
            this.userAgreementData.detail.forEach((item) => {
              this.sumMoney += item.amount;
            });
            if (type == "main") {
              if (this.browser) {
                this.userAgreement = true;
              } else {
                this.userAgreement = true;
                this.$nextTick(() => {
                  let dom = document.getElementById("word_11");
                  dom.scrollIntoView();
                });
              }
            }
          } else {
            console.log("获取用户协议的内容err===>", res.rltdesc);
          }
        })
        .catch((err) => {
          console.log("获取用户协议服务器开小差啦,请刷新后重试!", err);
        });
    },
    // 关闭弹框 初始化数据
    closePopup() {
      this.coupon = "";
      this.agentCode = "";
      this.sumMoney = 0;
      this.userAgreement = false;

      this.iconCouponFlag = false;
      this.iconAgentCodeFlag = false;
      this.loadingFlag = false;
      this.checked = false;
      this.totalMoney = this.totalMoneyYou;
      this.totalPrice = this.totalPriceYou;
    },
    // 同意并确认支付
    agreePayMoney() {
      if (Number(localStorage.getItem("WX_VERSION"))) {
        if (this.wxpayObj) {
          wxpayFunc(this.wxpayObj, this.wxPayCallback);
        }
      } else {
        location.href = this.dataForm;
      }
    },
    // 微信内支付回调函数
    wxPayCallback(res) {
      if (res.err_msg == "get_brand_wcpay_request:ok") {
        // 使用以上方式判断前端返回,微信团队郑重提示：
        //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
        commonNotify("用户支付成功!", this);

        this.loadingFlag = false;
        this.$http.refreshToken().then((res) => {
          this.bus.$emit("saveTokenHandle", res, 1);
          this.$router.push("/newFiles");
        });
      } else {
        warningNotify("用户支付失败!", this);

        this.loadingFlag = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/styles/variable.less";
.shopBox {
  margin: 10px 14px;
  .overthree {
    height: 86px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .message {
    height: 150px;
    background-image: url(../../../assets/shop/vipbg.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    -webkit-background-size: 100% 100%;
    padding: 20px 20px 0px;
    box-sizing: border-box;
    .img {
      display: flex;
      .word {
        margin-left: 16px;
        color: #9e7b57;
        font-size: 14px;
        padding: 4px 0;
        box-sizing: border-box;
        .user {
          font-size: 16px;
          font-weight: bold;
          margin: 0 0 10px;
        }
        .time {
          margin-top: 6px;
        }
      }
    }
    .bar {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
      .word {
        color: #9e7b57;
        font-size: 14px;
      }
    }
  }
}
.item-top-goumai {
  height: 50px;
  display: flex;
  .img {
    flex: 0 0 80px;
    margin-right: 20px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.money {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .title {
    font-size: 14px;
    font-weight: bold;
  }
  .yuan {
    color: #cb4649;
    font-size: 14px;
    font-weight: bold;
  }
  .year {
    font-size: 12px;
    color: #cb4649;
    margin-right: 6px;
  }
}
.chooseYear {
  margin-top: 16px;
  display: flex;
  text-align: center;
  // justify-content: flex-start;
  justify-content: space-around;
  .one {
    border: 1px solid #f2f2f2;
    width: 30%;
    padding: 10px 0;
    border-radius: 6px;
    p {
      margin: 0;
    }
    .year {
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 4px;
    }
    .yuan {
      margin-bottom: 4px;
      color: @--primary-color;
      .money {
        font-size: 18px;
        font-weight: bold;
      }
    }
    .yuanold {
      margin-bottom: 4px;
      font-size: 12px;
      color: #ccc;
    }
  }
  .yearActive {
    background-color: @--background-color;
    border: 1px solid #e5c693;
  }
}
.payMethods {
  margin-bottom: 2.6rem;
  font-size: 14px;
  color: #656565;
  p {
    margin: 20px 0;
  }
  /deep/.van-cell__title {
    display: flex;
    align-items: center;
  }
  .custom-title {
    margin-left: 10px;
  }
}
.item-center {
  display: flex;
  margin-top: 16px;
  .word {
    flex: 0 0 40px;
    padding: 2px 0 0 2px;
  }
  .tag {
    flex: 1;
    /deep/.van-tag--plain::before {
      border: 0.02667rem solid #ddd !important;
      font-size: 12px;
    }
  }
}
.shop-item {
  background: #fff;
  padding: 20px 10px;
  margin-bottom: 10px;
  position: relative;
  .sell {
    width: 40px;
    height: 40px;
    position: absolute;
    right: 0;
    top: 0;
    // &>img {
    //   width: 100%;
    //   height: 100%;
    // }
  }
  .item-top {
    height: 50px;
    display: flex;
    .img {
      flex: 0 0 80px;
      margin-right: 20px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .money {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .title {
        font-size: 14px;
        font-weight: bold;
      }
      .yuan {
        color: #cb4649;
        font-size: 14px;
        font-weight: bold;
      }
      .year {
        font-size: 12px;
        color: #cb4649;
        margin-right: 6px;
      }
    }
  }
  .item-center {
    display: flex;
    margin-top: 16px;
    .word {
      flex: 0 0 40px;
      padding: 2px 0 0 2px;
    }
    .tag {
      flex: 1;
      /deep/.van-tag--plain::before {
        border: 0.02667rem solid #ddd !important;
        font-size: 12px;
      }
    }
  }
  .bar {
    display: flex;
    justify-content: flex-end;
    .word {
      width: 70px;
      font-size: 12px;
    }
    .progress {
      display: flex;
      align-items: center;
    }
  }
  .buyBtn {
    margin-top: 20px;
    .show,
    .notshow {
      div {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        &:before,
        &:after {
          content: "";
          display: block;
        }
      }
    }
  }
}
.van-tag {
  margin: 2px;
}

// 续费
.item-top-xufei {
  margin: 0 10px;
  .word {
    font-weight: 700;
    margin: 14px 0;
  }
  /deep/.van-cell__title {
    display: flex;
    align-items: center;
  }
  .custom-title {
    margin-left: 10px;
  }
  .vip-box {
    background-color: #fff;
    padding: 10px 10px;
    .vip-box-item {
      display: flex;
      align-items: center;
      padding: 10px 0;
      .vip-title {
        flex: 0 0 60px;
        margin: 0 10px 0 10px;
      }
      .num {
        flex: 1;
      }
      .price {
        flex: 0 0 100px;
        text-align: right;
      }
    }
  }
  .chooseYear {
    margin: 16px 0;
    display: flex;
    text-align: center;
    justify-content: space-around;
    .one {
      border: 1px solid #f2f2f2;
      width: 30%;
      padding: 10px 0;
      border-radius: 6px;
      p {
        margin: 0;
      }
      .year {
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 4px;
      }
      .yuan {
        margin-bottom: 4px;
        color: @--primary-color;
        .money {
          font-size: 18px;
          font-weight: bold;
        }
      }
      .yuanold {
        margin-bottom: 4px;
        font-size: 12px;
        color: #ccc;
      }
    }
    .yearActive {
      background-color: @--background-color;
      border: 1px solid #e5c693;
    }
  }
}

// 协议
.userAgreementContent {
  padding: 0 10px;
  margin-bottom: 3rem;
  & > h4 {
    margin-bottom: 0;
  }
  .contentItemP {
    & > p {
      text-indent: 20px;
      margin: 0;
      margin-top: 4px;
    }
    & > h5 {
      margin: 0;
      margin-top: 4px;
    }
  }
  .marginT {
    margin-top: 20px;
  }
  .zhangStyle {
    position: relative;
    & > img {
      position: absolute;
      top: 42%;
      left: 28%;
    }
  }
}
</style>
